import React, {Component} from 'react';
import leftCenterIcon from "../../../components/image/leftCenter.png";

class FloatLeftTool extends Component {

    onClick = ()=>{
        this.props.editor.execCommand("imagefloat", "left");
    };

    getName(){
        return "floatLeftTool"
    }

    render() {
        return (
            <span>
                <img src={leftCenterIcon} onClick={()=>{this.onClick()}}/>
            </span>
        );
    }
}

export default FloatLeftTool;